/* src/app/location-users/location-sort/location-sort.component.scss */
.location-sort .sort-controls {
  display: flex;
  flex-direction: row;
}
.location-sort .sort-controls ups-select {
  width: 250px;
}
.location-sort .up-and-down-sort {
  box-shadow: none;
  background-color: white;
  border: thin #757575 solid;
  margin-left: 10px;
}
.location-sort .up-and-down-sort:before {
  font-family: upsicons, fantasy !important;
  content: "\e619" !important;
}
/*# sourceMappingURL=location-sort.component.css.map */
